/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import CommonToggle from "../../Common/CommonToggle";
import { Link, useNavigate, useLocation, useParams  } from "react-router-dom";
import { PRODUCT_APPLICATIONS_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";

const CreateApplications = () => {
    const Dispatch = useDispatch();
    const Navigate = useNavigate();
    const LocationRoute = useLocation()?.pathname?.split("/")[1];
    const { websocket } = useContext(WebSocketContext);
    const [ ApplicationState, setApplicationState ] = useState({
        BrandName: "",
        Status: true
    });
    const { roomId } = useParams();
    const { ClearFormSet, brandList, device_id } = useSelector((state) => state.adminReducers);
    const CurrentData_ = brandList?.list?.filter((elm) => elm?.id === roomId)[0];

    // error state
    const [ errorBrandName, seterrorBrandName ] = useState("");

    useEffect(() => {
        if(LocationRoute === "edit-product-application") {
            setApplicationState({
                ...ApplicationState,
                BrandName: CurrentData_?.brand_name,
                Status: CurrentData_?.is_active
            });
        };
    }, [ CurrentData_ ]);

    // create and edit brand
    const CreateBrand = () => {
        if(ApplicationState?.BrandName.trim() !== "") {
            Dispatch(ClearFormSetFutios({
                url: LocationRoute === "edit-product-application" ? "brand_edit" : "brand_add",
                action: true
            }));
            let param = { 
                "transmit": "broadcast", 
                "request" : { 
                    "brand_name" : ApplicationState?.BrandName.trim(), 
                    "is_active" : ApplicationState?.Status
                },
                "DeviceId" : device_id
            };
            if(LocationRoute === "edit-product-application") {
                param.url = "brand_edit";
                param.request.brand_id = CurrentData_?.id;
            } else {
                param.url = "brand_add";
            };
            wsSend_request(websocket, param);
        } else {
            CheckValid(ApplicationState?.BrandName.trim(), {type: 'BrandName', error: seterrorBrandName});
        };
    };

    useEffect(() => {
        if(ClearFormSet?.action === 200 && (ClearFormSet?.url === "brand_add" || ClearFormSet?.url === "brand_edit")) {
            Navigate(PRODUCT_APPLICATIONS_URL);
        };
    }, [ ClearFormSet ]);

    return(<section className="createApplcation_wrapper">
        <div className="MainHeader">
            <Link to={PRODUCT_APPLICATIONS_URL} className="btn btn-link backbtn"><i className="bi bi-arrow-left-short"></i> Back</Link>
        </div>
        <div className="tabsWrappers">
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3" >
                            <label className="form-label">Brand Name<span className="mendatory_star">*</span></label>
                            <input
                                type="text" 
                                className="form-control"
                                value={ApplicationState?.BrandName} 
                                onChange={(e) => setApplicationState({...ApplicationState, BrandName: e.target.value})}
                                onKeyUp={(e) => CheckValid(e.target.value, {type: 'BrandName', error: seterrorBrandName})}
                                onKeyDown={EmptySpaceFieldValid}
                                placeholder="Enter Brand Name" 
                            />
                            {errorBrandName !== "" && (<span className="error_medotory">{errorBrandName}</span>)}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <CommonToggle 
                            isBadgeAllow={true}
                            badgeTitle={"active_inactive"}
                            valueToggle={ApplicationState?.Status}
                            setValueToggle={() => setApplicationState({...ApplicationState, Status: !ApplicationState?.Status})}
                            name={"Status"}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <button 
                            disabled={ClearFormSet?.action === true && (ClearFormSet?.url === "brand_add" || ClearFormSet?.url === "brand_edit")}
                            className="btn formbtn widthfullbtn" 
                            onClick={() => CreateBrand()} 
                        >
                            {LocationRoute === "edit-product-application" ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>)
}

export default CreateApplications;